import { SxProps } from "@mui/system";
import { ThemeV2 } from "../../../util/types";
import { getInputStyles } from "../../../theme/styleHelpers";
import { hostThemes } from "../../../theme/hostThemes";

const { shell, composer } = hostThemes.chat;

export const inputContainer = (theme: ThemeV2): SxProps => ({
  width: "100%",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  borderRadius: {
    xs: 0,
    sm: `0 0 ${shell.cornerRadius}px ${shell.cornerRadius}px`,
  },
  alignItems: "center",
  backgroundColor: theme.tokens.color.action.primary,
  padding: {
    md: `${theme.tokens.spacing["4"]}px ${theme.tokens.spacing["2"]}px`,
    xs: `${theme.tokens.spacing["4"]}px ${theme.tokens.spacing["2"]}px ${theme.tokens.spacing["5"]}px ${theme.tokens.spacing["4"]}px`,
  },
});

export const undoButtonWrapper = (theme: ThemeV2): SxProps => ({
  marginRight: `${theme.tokens.spacing["2"]}px`,
  paddingTop: `${theme.tokens.spacing["1"]}px`,
});

export const buttonStyle = (theme: ThemeV2): SxProps => ({
  backgroundColor: `color-mix(in srgb, ${theme.tokens.color.surface.card} 55%, transparent)`,
  color: theme.tokens.color.text.inverse,
  textTransform: "initial",
});

export const placeholderContainer = (theme: ThemeV2): SxProps => ({
  ...getInputStyles(theme),
  fontSize: theme.tokens.typography.size,
  flex: 1,
  borderRadius: `${theme.tokens.shape.radius.md}px`,
  paddingY: {
    md: `${composer.placeholderPaddingDesktop}px`,
    xs: `${composer.placeholderPaddingMobile}px`,
  },
  paddingLeft: `${composer.placeholderPaddingLeft}px`,
  color: theme.tokens.color.text.secondary,
});
